// Informações centralizadas para uso nos componentes
export const PHONE = '(41)7403-7997';
export const EMAIL = 'psicoinfantil@larafrassonpsicologainfantil.com';
export const ADDRESS = 'Rua Albino Silva, 455. Bom Retiro, Curitiba/PR';
export const WHATSAPP_LINK = 'https://wa.me/554174037997';
export const INSTAGRAM_LINK = 'https://www.instagram.com/psicolarafrasson/';
export const LINKEDIN_LINK = 'https://www.linkedin.com/in/lara-frasson-0881b11b0/';
export const FACEBOOK_LINK = 'https://www.facebook.com/psicolarafrasson/';
export const CRP = '08/33121';

// Links de produtos/cursos
export const EMPATEA_HOTMART_LINK = 'https://pay.hotmart.com/P101412929E?bid=1760913298487';
